export default `query($from: String!, $to: String!, $profile: String) {    
                  getItemsIDNoticed(from: $from, to: $to, profile: $profile) {articleIds} }`;